export const currentOrigin = () => {
    return window.location.origin;
};

export const getSessionStorage = () => {
    return sessionStorage;
};

export const currentHash = (): string => {
    return window.location.hash;
};

export const currentSearch = (): string => {
    return window.location.search;
};

export const currentPathname = () => {
    return window.location.pathname;
};

export const currentDocumentTitle = (): string => {
    return document.title;
};

export const historyReplaceState = (
    data: string | null,
    unused: string,
    url?: string | URL | null
) => {
    history.replaceState(data, unused, url);
};

export const locationReplace = (url: string | URL) => {
    window.location.replace(url);
};

export const locationAssign = (url: string | URL) => {
    window.location.assign(url);
};

export const getCryptoRandomValues = <T extends ArrayBufferView>(
    array: T
): T => {
    return window.crypto.getRandomValues(array);
};

export const cryptoSubtle = (): SubtleCrypto => {
    return window.crypto.subtle;
};

export const fetch = (
    input: RequestInfo | URL,
    init?: RequestInit
): Promise<Response> => {
    return window.fetch(input, init);
};
